// extracted by mini-css-extract-plugin
export default {"page":"Courses_page__KViGE","content":"Courses_content__CF5yZ","badge":"Courses_badge__OBKBf","catalogLink":"Courses_catalogLink__jGdye"};